import { render, staticRenderFns } from "./Alias.vue?vue&type=template&id=f7ff0b80&"
import script from "./Alias.vue?vue&type=script&lang=js&"
export * from "./Alias.vue?vue&type=script&lang=js&"
import style0 from "./Alias.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Alias.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports